module.exports = __webpack_public_path__ + "img/223.8c738b24.jpg";